export default function MapPoint() {
  return null;
}

MapPoint.displayName = "MapPoint";
